import {call, put, select} from 'redux-saga/effects';
import {requestContext} from '../../../../../../common/requestContext';
import {AppState} from '../../../../../../state/store';
import {setCurrentPageCount} from '../state/textViewerSlice';
import {CountTriggerTextViewerCoreOption} from '../type/CountTriggerTextViewerCoreOption.interface';
import {FrameSize} from '../type/FrameSize.interface';
import {TextViewerReadType} from '../type/TextViewerReadType';
import {getPageCount} from './getPageCount';
import {getTextViewerCoreOption} from './getTextViewerCoreOption.saga';

export function* countCurrentPageCount({
  productId,
  size,
  isPreview,
}: {
  productId: number;
  size: FrameSize;
  isPreview?: boolean;
}) {
  const {currentHtmlInfo, readType} = yield select((state: AppState) => ({
    currentHtmlInfo: state.textViewer.viewData[productId]?.currentHtmlInfo,
    readType: state.textViewer.settings.readType,
  }));

  if (!currentHtmlInfo) {
    yield put(setCurrentPageCount({productId, pageCount: 0}));
    return;
  }

  const option: CountTriggerTextViewerCoreOption = yield call(
    getTextViewerCoreOption,
    {
      size,
      isMobile: requestContext.requestInfo.display.isMobile,
    }
  );
  const pageCount: number = yield call(getPageCount, {
    htmlInfo: currentHtmlInfo,
    option,
    readType: isPreview ? TextViewerReadType.Scroll : readType,
  });

  yield put(setCurrentPageCount({productId, pageCount}));
}
